<div class="st-page">
  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'feesReports' | translate }}</h1>
      <p class="st-subtitle" *ngIf="reportType === 'overdue'">
        <span *ngIf="!fetchingOverdueClassListData">{{ 'updated' | translate }} {{ overdueLastUpdatedLabel }}</span>
        <span class="sfr-subtitle-skeleton" *ngIf="fetchingOverdueClassListData"></span>
      </p>
      <p class="st-subtitle" *ngIf="reportType === 'pending'">
        <span *ngIf="!fetchingPendingClassListData">{{ 'updated' | translate }} {{ pendingLastUpdatedLabel }}</span>
        <span class="sfr-subtitle-skeleton" *ngIf="fetchingPendingClassListData"></span>
      </p>
    </div>
    <button type="button" class="sfr-icon-btn" *ngIf="reportType === 'overdue'" [disabled]="refreshingOverdueList" (click)="refreshOverdueList()">
      <i class="ri-refresh-line"></i>
    </button>
    <button type="button" class="sfr-icon-btn" *ngIf="reportType === 'pending'" [disabled]="refreshingPendingList" (click)="refreshPendingList()">
      <i class="ri-refresh-line"></i>
    </button>
  </div>

  <div class="st-tabs">
    <div class="st-tab" [class.active]="reportType === 'overdue'" (click)="setType('overdue')">
      <i class="ri-error-warning-line"></i> {{ 'overdue' | translate }} ({{ overdueClassRows.length }})
    </div>
    <div class="st-tab" [class.active]="reportType === 'pending'" (click)="setType('pending')">
      <i class="ri-time-line"></i> {{ 'pending' | translate }} ({{ pendingClassRows.length }})
    </div>
  </div>

  <!-- ---------- Overdue tab (class-summary) ---------- -->
  <ng-container *ngIf="reportType === 'overdue'">
    <div class="st-tv-list" *ngIf="fetchingOverdueClassListData">
      <div class="st-card sfr-skeleton-card" *ngFor="let s of [1,2,3,4,5,6,7,8]"></div>
    </div>

    <ng-container *ngIf="!fetchingOverdueClassListData">
      <div class="sfr-class-list" *ngIf="overdueClassRows.length">
        <div class="st-card sfr-class-card" *ngFor="let c of overdueClassRows" (click)="openOverdueClass(c)">
          <div class="sfr-class-left">
            <div class="sfr-class-name">{{ overdueClassLabel(c) }}</div>
            <div class="sfr-class-sub">{{ 'totalStudents' | translate }}: {{ c.totalActiveStudentCount }}</div>
          </div>
          <div class="sfr-class-right">
            <div class="sfr-class-amount">{{ formatAmount(c.activeStudentTotalOverdueAmount) }}</div>
            <div class="sfr-class-sub">{{ 'tapToSee' | translate }} {{ c.activeStudentOverdueCount }}</div>
          </div>
        </div>
      </div>

      <div class="st-empty-state" *ngIf="!overdueClassRows.length">
        <i class="ri-file-list-3-line"></i> {{ 'noFeesDataAvailable' | translate }}
      </div>
    </ng-container>

    <div class="sfr-sort-bar" *ngIf="overdueClassRows.length">
      <button type="button" class="sfr-sort-segment" [class.active]="overdueSortKey === 'dueFees'" (click)="setOverdueSort('dueFees')">
        {{ 'dueFees' | translate }} <i class="ri-arrow-up-down-line"></i>
      </button>
      <button type="button" class="sfr-sort-segment" [class.active]="overdueSortKey === 'studentCount'" (click)="setOverdueSort('studentCount')">
        {{ 'noOfStudents' | translate }} <i class="ri-arrow-up-down-line"></i>
      </button>
    </div>
  </ng-container>

  <!-- ---------- Pending tab (class-summary) ---------- -->
  <ng-container *ngIf="reportType === 'pending'">
    <div class="st-tv-list" *ngIf="fetchingPendingClassListData">
      <div class="st-card sfr-skeleton-card" *ngFor="let s of [1,2,3,4,5,6,7,8]"></div>
    </div>

    <ng-container *ngIf="!fetchingPendingClassListData">
      <div class="sfr-class-list" *ngIf="pendingClassRows.length">
        <div class="st-card sfr-class-card" *ngFor="let c of pendingClassRows" (click)="openPendingClass(c)">
          <div class="sfr-class-left">
            <div class="sfr-class-name">{{ pendingClassLabel(c) }}</div>
            <div class="sfr-class-sub">{{ 'totalStudents' | translate }}: {{ c.totalActiveStudentCount }}</div>
          </div>
          <div class="sfr-class-right">
            <div class="sfr-class-amount">{{ formatAmount(c.activeStudentTotalPendingAmount) }}</div>
            <div class="sfr-class-sub">{{ 'tapToSee' | translate }} {{ c.activeStudentPendingCount }}</div>
          </div>
        </div>
      </div>

      <div class="st-empty-state" *ngIf="!pendingClassRows.length">
        <i class="ri-file-list-3-line"></i> {{ 'noFeesDataAvailable' | translate }}
      </div>
    </ng-container>

    <div class="sfr-sort-bar" *ngIf="pendingClassRows.length">
      <button type="button" class="sfr-sort-segment" [class.active]="pendingSortKey === 'dueFees'" (click)="setPendingSort('dueFees')">
        {{ 'dueFees' | translate }} <i class="ri-arrow-up-down-line"></i>
      </button>
      <button type="button" class="sfr-sort-segment" [class.active]="pendingSortKey === 'studentCount'" (click)="setPendingSort('studentCount')">
        {{ 'noOfStudents' | translate }} <i class="ri-arrow-up-down-line"></i>
      </button>
    </div>
  </ng-container>
</div>
